<template>
    <div class="product">
        <div class="pro01">
            <div class="proTxt">
                <h2 class="text-center">新能源光储充集成系统</h2>
                <p>中恒新能源光储充集成系统，结合云计算、大数据、物联网等新技术，通过云端、PC端、手机端多端融合，具有数据的实时监测、电权管理、收费管理、数据统计分析、告警查询等模块。通过充电桩终端设备参数的上报，实现充电桩运行情况的实时监控;同时平台系统也可下发指令至终端设备，实现对设备的远程调试、维护和升级。</p>
            </div>
            <div class="proImg">
                <img src="../../assets/img/product/pic01.png" alt class="img-responsive center-block" />
            </div>
        </div>

        <div class="proBgf">
            <div class="container">

                <el-row type="flex" justify="space-around" >
                    <el-col :span="7">
                        <div class="grid-content">
                            <img src="../../assets/img/product/icon-pro-1.png" alt class="img-responsive center-block">
                            <h4>无桩充电</h4>
                            <p>人机交互和充电控制功能模块移至后台管控系统，将传统充电桩升级为“抗碾压、防浸水、不占空间”的车挡式充电终端，安全、不占空间。</p>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="grid-content">
                            <img src="../../assets/img/product/icon-pro-2.png" alt class="img-responsive center-block">
                            <h4>无电插头</h4>
                            <p>拔下充电枪，即刻断电，插上充电枪并认证通过后才可通电，防护等级IP54，彻底杜绝安全隐患。</p>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="grid-content">
                            <img src="../../assets/img/product/icon-pro-3.png" alt class="img-responsive center-block">
                            <h4>群管群控</h4>
                            <p>专利箱变技术，实现电路系统、管控系统的高度集成，通过统一调度、统一管理，实现削峰填谷，降低对电网的冲击。</p>
                        </div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="space-around" >
                    <el-col :span="7">
                        <div class="grid-content">
                            <img src="../../assets/img/product/icon-pro-4.png" alt class="img-responsive center-block">
                            <h4>模块结构</h4>
                            <p>充电系统模块化设计，抽屉式交、直流充电模块可根据需要灵活配置。维护便捷、扩容方便、一次性投资少。</p>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="grid-content">
                            <img src="../../assets/img/product/icon-pro-5.png" alt class="img-responsive center-block">
                            <h4>主动防护</h4>
                            <p>通过对BMS报文和充电过程数据分析，对异常数据采取主动性保护措施，保证充电过程安全和充电后的车辆电池安全。</p>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="grid-content">
                            <img src="../../assets/img/product/icon-pro-6.png" alt class="img-responsive center-block">
                            <h4>柔性充电</h4>
                            <p>通过多区段调节，多维度补偿，历史充电趋势追溯，实现电流、电压柔性输出，延长电池寿命周期。</p>
                        </div>
                    </el-col>
                </el-row>
                
            </div>
        </div>

    </div>
    
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.product {
    width: 100%;
    height: 100%;
}

.center-block {
    display: block;
    margin-right: auto;
    margin-left: auto;
}

.img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
}

.pro01 {
    margin-top: 50px;
    position: relative;
    width: 100%;
    height: 750px;
    background: url(../../assets/img/banner4.jpg) no-repeat top center;

    .proTxt {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        width: 100%;

        h2 {
            max-width: 900px;
            color: #fff;
            margin: 80px auto 30px;
            font-size: 36px;
            font-weight: 500;
        }

        .text-center {
            text-align: center;
        }

        p {
            max-width: 900px;
            margin: 5px auto;
            text-indent: 2em;
            line-height: 30px;
        }
    }

    .proImg {
    }
}



.proBgf {
    background: #fff;
    padding: 60px 0 60px;
    // height: 800px;

    .container {
        margin: auto;
        width: 100%;
        max-width: 1200px;
        min-width: 1200px;
    }

    h4{
        font-size: 20px;
        font-weight: 500;
        color: #4299d6;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    p{
        margin: 0 0 10px;
        line-height: 26px;
        color: #666;
        font-size: 16px;
    }
}

.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

</style>